import { render } from "./P404.vue?vue&type=template&id=1720bbfa"
import script from "./P404.vue?vue&type=script&lang=js"
export * from "./P404.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\vueproject\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__